<div class="font-resizer-wrapper" cdkDragLockAxis="y" cdkDrag>
  <button mat-button (click)="fontdec()">A-</button>
  <button mat-button (click)="fontdefault()">A</button>
  <button mat-button (click)="fontInc()">A+</button>
</div>
